var AppDispatcher = require('../core/AppDispatcher.jsx');
var ApplicationConstants = require('../constants/ApplicationConstants');
var Constants = require('../constants/YourDetailsConstants');

var ApplicationActionTypes = ApplicationConstants.ActionTypes;
var ActionTypes = Constants.ActionTypes;

module.exports = {
    loadTitleList: function (titles) {
        AppDispatcher.dispatch({
            actionType: ApplicationActionTypes.LOAD_TITLE_LIST,
            titles: titles
        });
    },
    loadTfnExemptionList: function (tfnExemptionList) {
        AppDispatcher.dispatch({
            actionType: ApplicationActionTypes.LOAD_TFN_EXEMPTION_LIST,
            tfnExemptionList: tfnExemptionList
        });
    },
    loadCountryList: function (countryList) {
        AppDispatcher.dispatch({
            actionType: ApplicationActionTypes.LOAD_COUNTRY_LIST,
            countryList: countryList
        });
    },
    saveAddressInfo: function (fieldId, componentId, fieldValue, index) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SAVE_ADDRESS_INFO,
            fieldId: fieldId,
            componentId: componentId,
            fieldValue: fieldValue,
            index: index
        });
    },
    saveBusinessAddress: function (fieldId, componentId, fieldValue, index) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SAVE_BUSINESS_ADDRESS,
            fieldId: fieldId,
            componentId: componentId,
            fieldValue: fieldValue,
            index: index
        });
    },
    retrieveYourDetails: function (data) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.RETRIEVE_YOUR_DETAILS,
            data: data
        });
    },
    addAddtionalInvestors: function (isCorporate) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.ADD_ADDITIONAL_INVESTORS,
            isCorporate: isCorporate
        });
    },
    updateYourDetailsData: function (fieldId, componentId, fieldValue, index) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.UPDATE_YOUR_DETAILS,
            fieldId: fieldId,
            componentId: componentId,
            fieldValue: fieldValue,
            index: index
        });
    },
    removeValidation: function(listOfIds){
        AppDispatcher.dispatch({
            actionType: ActionTypes.YOUR_DETAILS_REMOVE_VALIDATION,
            listOfIds: listOfIds
        });
    },
    addTrustee: function(isCorporate, index){
        AppDispatcher.dispatch({
            actionType: ActionTypes.ADD_TRUSTEE,
            isCorporate: isCorporate,
            index: index
        });  
    },
    deleteTrustee: function(index){
        AppDispatcher.dispatch({
            actionType: ActionTypes.DELETE_TRUSTEE,
            index: index
        });  
    },
    loadSourceOfFundList: function (sourceOfFundList) {
        AppDispatcher.dispatch({
            actionType: ApplicationActionTypes.LOAD_SOURCEOFFUND_LIST,
            sourceOfFundList: sourceOfFundList
        });
    },
    loadSourceOfWealthList: function (sourceOfWealthList) {
        AppDispatcher.dispatch({
            actionType: ApplicationActionTypes.LOAD_SOURCEOFWEALTH_LIST,
            sourceOfWealthList: sourceOfWealthList
        });
    }
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./actions/YourDetailsActions.js